/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

import superProAllMeasurementsMap from './super-pro-all-measurements-map.tpl.html';// eslint-disable-line

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.farmer.superProAllMeasurementsMap', [])
    .directive('superProAllMeasurementsMap', SuperProAllMeasurementsMap)
    .name;

/*@ngInject*/
function SuperProAllMeasurementsMap() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '=',
            device: '='
        },
        controller: SuperProAllMeasurementsMapController,
        controllerAs: 'vm',
        templateUrl: superProAllMeasurementsMap
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function SuperProAllMeasurementsMapController($scope, $log, types, agUtils, timeService) {// eslint-disable-line

    let vm = this;

    vm.loading = false;
    vm.measurements = [];

    vm.measurementsSubscriptionOptions = {
        callbacks: {
            onDataUpdated: onDataUpdated,
            onDataUpdateError: onDataUpdateError,
            dataLoading: (subscription) => {
                vm.loading = subscription.loadingData;
            }
        },
        timeWindowConfig: timeService.defaultTimewindow(),
        useDashboardTimewindow: false
    };

    vm.measurementsSubscriptionOptions.timeWindowConfig.aggregation.type = types.aggregation.none.value;
    vm.measurementsSubscriptionOptions.timeWindowConfig.realtime.timewindowMs = Date.now() - 1262304000000;

    $scope.$watch(() => { return vm.device ? vm.device.label : null; }, (title) => {
        if (vm.ctx && title) {
            reset();
            vm.measurements = [];
            vm.ctx.widgetTitle = title + ' (' + agUtils.getFarmerDeviceName(vm.device.type) + '): Map of Measurements';
            let measurementsSubscriptionInfo = [{
                type: types.datasourceType.entity,
                entityType: types.entityType.device,
                entityId: vm.device.id.id,
                entityName: vm.device.label,
                timeseries: [{
                    name: "measurement"
                }]
            }];
            vm.ctx.subscriptionApi.createSubscriptionFromInfo(types.widgetType.timeseries.value, measurementsSubscriptionInfo, vm.measurementsSubscriptionOptions, false, true).then(
                (subscription) => {
                    vm.measurementsSubscription = subscription;
                }
            )
        }
    });

    function onDataUpdated(subscription) {
        let data = angular.toJson(subscription.data);
        if (vm.latestData && (vm.latestData === data)) {
            return;
        } else {
            vm.latestData = data;
            if (subscription.data.length) {
                vm.measurements = subscription.data[0].data.map((value) => {
                    let res = angular.fromJson(value[1]);
                    res.ts = value[0];
                    return res;
                })
            }
        }
    }

    function onDataUpdateError(subscription, e) {
        $log.error(e);
    }

    $scope.$on('$destroy', () => {
        reset();
    });

    function reset() {
        if (vm.measurementsSubscription) {
            vm.ctx.subscriptionApi.removeSubscription(vm.measurementsSubscription.id);
        }
    }
}